import ApiBase from '../ApiBase';

class Users extends ApiBase {
    route = '/networking/users';

    enabled(params) {
        return this.get(this.route, params);
    }
}

export default new Users;
